var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15548 6.43408H1.14045C0.962258 6.43408 0.817871 6.57853 0.817871 6.75666V19.6552C0.817871 19.8334 0.962258 19.9778 1.14045 19.9778H5.15548C5.33368 19.9778 5.47806 19.8334 5.47806 19.6552V6.75666C5.47806 6.57853 5.33368 6.43408 5.15548 6.43408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14942 0.0219727C1.68852 0.0219727 0.5 1.2092 0.5 2.66849C0.5 4.12842 1.68852 5.3161 3.14942 5.3161C4.60916 5.3161 5.79671 4.12836 5.79671 2.66849C5.79677 1.2092 4.60916 0.0219727 3.14942 0.0219727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.368 6.11377C13.7555 6.11377 12.5634 6.80699 11.8404 7.59467V6.75693C11.8404 6.5788 11.696 6.43435 11.5178 6.43435H7.67268C7.49448 6.43435 7.3501 6.5788 7.3501 6.75693V19.6555C7.3501 19.8337 7.49448 19.9781 7.67268 19.9781H11.6789C11.8571 19.9781 12.0015 19.8337 12.0015 19.6555V13.2737C12.0015 11.1232 12.5856 10.2854 14.0847 10.2854C15.7174 10.2854 15.8471 11.6285 15.8471 13.3843V19.6556C15.8471 19.8338 15.9915 19.9782 16.1697 19.9782H20.1775C20.3556 19.9782 20.5 19.8338 20.5 19.6556V12.5805C20.5 9.38274 19.8903 6.11377 15.368 6.11377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.45689c9b92ceffd663fa878c9cf01659.svg";
export { ForwardRef as ReactComponent };